module.exports = __webpack_public_path__ + "img/HomeMain.e897f714.jpg";